$(".jsBodyIndexScroll").on("click", "li", function (e) {
  e.stopPropagation();
  var clickText = $(this).text();
  var targetObj = null;

  // 一致するh2を取得する
  $("h2").each(function () {
    var h2Text = $(this).text();
    if (clickText == h2Text) {
      targetObj = $(this);
    }
  });
  // h2になかったらh3を探す
  if (!targetObj) {
    $("h3").each(function () {
      var h2Text = $(this).text();
      if (clickText == h2Text) {
        targetObj = $(this);
      }
    });
  }
  window.helpers.scrollTo.go(targetObj);
});

$(".jsBodyIndexClose").on("click", function () {
  $(this).parent(".article-body-index").addClass("style-closed");
});

$(".jsBodyIndexOpen").on("click", function () {
  $(this).parent(".article-body-index").removeClass("style-closed");
});
